export default __webpack_public_path__ + "static/media/ForSale.f0730a1b.jpg";